import { render } from "./ExclusionForm.vue?vue&type=template&id=5ae5715f"
import script from "./ExclusionForm.vue?vue&type=script&lang=js"
export * from "./ExclusionForm.vue?vue&type=script&lang=js"

import "./ExclusionForm.vue?vue&type=style&index=0&id=5ae5715f&lang=css"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__